module.exports = require('../impls/exec-pipe/exec-pipe.js').execPipe;